The details of a position that a candidate is associated with.
